import React, { Component } from 'react';
import { Icon } from 'antd';
import MyInput from 'components/controls/MyInput';
import DropdownList from 'components/controls/DropdownList';
import InputCheck from 'components/controls/InputCheck';
import _validator from 'modules/validator';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import _AdminService from '../../modules/AdminService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import NavigationTab from './NavigationTab_new_one';
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// replaces this page's 2 `.candidateform-cover` sections.
import Card from 'components/enterprise/Card';

import { ST_CATEGORY_ID, SC_CATEGORY_ID, OPEN_CATEGORY_ID1, EWS_CATEGORY_ID1 } from "../../constants/constants"

import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Phase E migration: validation messages are set via setState with a plain string, so they use the
// plain resolveText() helper — see NewLogin.jsx's identical comment for why.
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class CandidateReservationDetails_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            categoryList: [],
            loading: false,
            Fees: 0,
            config: {},
            categoryError: '',
            casteError: '',
            nonCreamyLayerError:""
        };
    }

    componentDidMount() {
        this.GetStudentReservationData();
        this.getConfigurations();
    }

    getConfigurations = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let temp = await _StudentService.GetCandidatePostData();
                    this.setState({
                        ...this.state,
                        config: temp.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    GetStudentReservationData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let categoryList = await _StudentService.getAllCategory(this.props.data.Applied_PostId);
                    let categoryData = await _StudentService.getStudentReservationData();

                    this.setState({
                        ...this.state,
                        categoryList: categoryList.data,
                        data: categoryData.data,
                        loading: false
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    updateStudentReservationData = async () => {
        try {

            if (this.validate()) {
                return
            }

            this.setState({
                loading: true
            }, async () => {
                try {
                    let body = { ...this.state.data };
                    //console.log(body);

                    const response = await _StudentService.updateStudentReservationData(body);
                    //console.log(response);
                    
                    if (response.data.IsSuccess) {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('success', 'Reservation details saved successfully.');
                            this.onTabOrderChange();
                            //this.props.history.push({pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId }})
                        })
                    }
                    else {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('error', response.data.Message);
                        })
                    }
                } catch (e) {
                    // TODO
                    console.log('Error: ', e);
                }
            });

        } catch (e) { }
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(3);
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onPrevious = () => {
        this.props.onTabOrderChange(1);
    }

    onTextChange = (event) => {
        if (event.target.name == 'Caste' && event.target.value.length > 25)
            return;

        this.setState({
            data: {
                ...this.state.data,
                [event.target.name]: event.target.value,
            },
        });
    }

    onCategoryChange = (event) => {
        let temp = this.state.categoryList.find((item) => item.Id == event.target.value);
        let tempFee = 0;
        if (temp) {
            //console.log("Temp: ", temp);
            tempFee = isNaN(temp.Fees) ? 0 : temp.Fees;
        }

        this.setState({
            data: {
                ...this.state.data,
                [event.target.name]: event.target.value,
                Exam_Fee: tempFee
            },
        });
    }

    onChangeNoncreamylayer = e => {
        //console.log(!this.state.data.Is_NonCreamyLayer_Available);
        this.setState({
            data: {
                ...this.state.data,
                Is_NonCreamyLayer_Available: !this.state.data.Is_NonCreamyLayer_Available,
            },
        });
    };

    onChangeReservations = e => {
        //console.log(e.target.name, " ", this.state.data[e.target.name]);
        this.setState({
            data: {
                ...this.state.data,
                [e.target.name]: !this.state.data[e.target.name],
            },
        });
    };

    validate = () => {
        let body = { ...this.state.data };
        //console.log("final body: ", body);

        this.setState({
            categoryError: '',
            casteError: '',
            nonCreamyLayerError:""
        });

        let hasError = false;

        if (this.state.config.IsCategoryMandatory) {
            if (!body.Category_Id) {
                this.setState({ categoryError: tr('reservationDetails.categoryRequiredError') });
                hasError = true
            }

            if (!body.Caste || !body.Caste.trim()) {
                this.setState({ casteError: tr('reservationDetails.casteRequiredError') });
                hasError = true
            }
            
            if(this.state.data.Category_Id !== 10 &&
                this.state.data.Category_Id !== ST_CATEGORY_ID &&
                this.state.data.Category_Id !== SC_CATEGORY_ID &&
                this.state.data.Category_Id !== EWS_CATEGORY_ID1 &&
                this.state.data.Category_Id !== OPEN_CATEGORY_ID1){
                    if (body.Is_NonCreamyLayer_Available === false) {
                        this.setState({ nonCreamyLayerError: tr('reservationDetails.nonCreamyLayerRequiredError') });
                        hasError = true
                    }
                }
        }

        return hasError;
    }

    //const StudentPersonalInfo = () => {
    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <>
                <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={2} />

                {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                <div className="candidate-reservation ent-container gl-bxbr  analysisWrap p-4 mt-3">
                    <h4 className="ch-heading4 mb-3"><Text k="reservationDetails.pageHeading" /></h4>
                    <Card header={<h5 className="ch-heading5"><Text k="reservationDetails.categoryCasteFeesHeading" /></h5>}>
                        {this.state.config.IsCategoryMandatory &&
                        <div className="container-fluid pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.state.data.Category_Id ? this.state.data.Category_Id : 0}
                                        name="Category_Id"
                                        onChange={this.onCategoryChange}
                                        placeholder={tr('reservationDetails.selectCategoryPlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="reservationDetails.categoryLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        isDisabled={true}
                                        options={this.state.categoryList}
                                        errorState={this.state.categoryError}
                                        errorMessage={this.state.categoryError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Caste ? this.state.data.Caste : ""}
                                        name="Caste"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="reservationDetails.casteLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.casteError}
                                        errorMessage={this.state.casteError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Exam_Fee ? this.state.data.Exam_Fee : 0}
                                        name="Fees"
                                        heading={<div className='displayInGrid'><Text k="reservationDetails.feesLabel" /></div>}
                                        disabled={true}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={false}
                                    />
                                </div>
                            </div>
                        </div> 
                        }
                        {
                        this.state.data.Category_Id !== 10 &&
                        this.state.data.Category_Id !== ST_CATEGORY_ID &&
                        this.state.data.Category_Id !== SC_CATEGORY_ID &&
                        this.state.data.Category_Id !== OPEN_CATEGORY_ID1 && 
                        this.state.data.Category_Id !== EWS_CATEGORY_ID1 &&
                        <div className="container-fluid pr-0 pl-0"> 
                            <div className="row flex-sm-row ">
                                <div className="col-sm-12">
                                    <InputCheck
                                        id="Is_NonCreamyLayer_Available"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.nonCreamyLayerCertificateLabel" /> <span className="color-red">*</span></div>}
                                        className="mr-3 mb-0"
                                        name="Is_NonCreamyLayer_Available"
                                        value="false"
                                        onChange={this.onChangeNoncreamylayer}
                                        checked={this.state.data.Is_NonCreamyLayer_Available ? this.state.data.Is_NonCreamyLayer_Available : false}
                                    />
                                </div>
                                <div className="col-sm-12">
                                    {
                                        this.state.nonCreamyLayerError === "" ? "" : <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.nonCreamyLayerError}</label>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </Card>

                    {this.state.config.IsAgeRelaxationMandetory &&
                        <Card header={<h5 className="ch-heading5"><Text k="reservationDetails.ageRelaxationHeading" /></h5>} className="mt-4">
                        <div className="container-fluid pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Ex_Serviceman"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.exServicemanLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Ex_Serviceman"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Ex_Serviceman ? this.state.data.Ex_Serviceman : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Is_Ladies"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.ladiesLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Is_Ladies"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Is_Ladies ? this.state.data.Is_Ladies : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Is_Handicaped"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.handicapedLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Is_Handicaped"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Is_Handicaped ? this.state.data.Is_Handicaped : false}
                                    />
                                </div>
                            </div>
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Earth_Quake_Affected"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.earthQuakeAffectedLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Earth_Quake_Affected"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Earth_Quake_Affected ? this.state.data.Earth_Quake_Affected : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Is_Player"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.playerLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Is_Player"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Is_Player ? this.state.data.Is_Player : false}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <InputCheck
                                        id="Is_Anshkalin"
                                        type="checkbox"
                                        label={<div className='displayInGrid'><Text k="reservationDetails.anshkalinLabel" /></div>}
                                        className="mr-3 mb-0"
                                        name="Is_Anshkalin"
                                        value="false"
                                        onChange={this.onChangeReservations}
                                        checked={this.state.data.Is_Anshkalin ? this.state.data.Is_Anshkalin : false}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>
                    }

                    <div className="row mt-4">
                        <div className="col-12">
                            <div className=" form-action d-flex justify-content-end ">
                                <ButtonComponent
                                    id="btnCancel"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="reservationDetails.cancelButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onCancel} />

                                <ButtonComponent
                                    id="btnPrevious"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="reservationDetails.previousButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onPrevious} />

                                <ButtonComponent
                                    id="btnSubmit"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="reservationDetails.saveButton" /></div>}
                                    className="button-global button-primary autoHeight"
                                    onClick={this.updateStudentReservationData} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    };
}

export default CandidateReservationDetails_new;